import { SquarePen } from "lucide-react";
import React from "react";
import "./shell.css";

import { IconButton } from "@lattice/frontend/components/kit/IconButton";

export type T_ShellHeaderProps = {
  historyControlsId: string;
  historyOpen: boolean;
  onNewChat: () => void;
  onToggleHistory: () => void;
  threadTitle: string | null;
};

/** Shell top bar. History stays left, New chat stays right, and conversation
 * context remains centered at every web breakpoint. */
export function ShellHeader({
  historyControlsId,
  historyOpen,
  onNewChat,
  onToggleHistory,
  threadTitle,
}: T_ShellHeaderProps) {
  return (
    <header className="shell-header">
      <IconButton
        ariaControls={historyControlsId}
        ariaExpanded={historyOpen}
        ariaLabel="Toggle conversation history"
        icon={
          <svg
            aria-hidden
            fill="none"
            height={18}
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth={2}
            viewBox="0 0 24 24"
            width={18}
          >
            <line x1="3" x2="21" y1="6" y2="6" />
            <line x1="3" x2="15" y1="12" y2="12" />
            <line x1="3" x2="18" y1="18" y2="18" />
          </svg>
        }
        onClick={onToggleHistory}
        variant="quiet"
      />
      <p className="shell-header__title">{threadTitle ?? ""}</p>
      <div className="shell-header__new-chat">
        <IconButton
          ariaLabel="New chat"
          icon={<SquarePen aria-hidden size={18} />}
          onClick={onNewChat}
          variant="quiet"
        />
      </div>
    </header>
  );
}
